import * as Yup from 'yup';
import i18next from 'i18next';
import { ClienteEnum } from '../../../api/models/Enums';
import { isMarket } from '../../../utils/markets';
import { Markets } from '../../../types';

export const validationLeadSfAccount = Yup.object().shape({
	Cliente__c: Yup.string().required(i18next.t('client_type_mandatory')),
	Partita_IVA__c: Yup.string().when('Cliente__c', {
		is: (value: ClienteEnum) =>
			[ClienteEnum.Azienda, ClienteEnum.Libero_Professionista].includes(value),
		then: (schema) => {
			if (isMarket(Markets.it)) {
				return schema
					.required(i18next.t('required_field'))
					.length(11, i18next.t('business_fiscal_code_length_error_11_chars'))
					.matches(
						/^\d{11}$/,
						i18next.t('business_fiscal_code_length_error_11_chars')
					);
			}
			if (isMarket(Markets.es)) {
				return schema
					.required(i18next.t('required_field'))
					.length(9, i18next.t('business_fiscal_code_length_error'));
			}
			return schema.required(i18next.t('required_field'));
		},
		otherwise: (schema) => schema.notRequired(),
	}),
	Name: Yup.string().when('Cliente__c', {
		is: (value: ClienteEnum) => value === ClienteEnum.Azienda,
		then: (schema) => schema.required(i18next.t('required_field')),
	}),
	Codice_Fiscale__c: Yup.string().when('Cliente__c', {
		is: (value: ClienteEnum) => value === ClienteEnum.Privato,
		then: (schema) => {
			if (isMarket(Markets.it)) {
				return schema
					.required(i18next.t('required_field'))
					.length(
						16,
						i18next.t('codice_fiscale_format_error_16_chars_no_symbols')
					)
					.matches(
						/^[A-Z0-9]{16}$/,
						i18next.t('codice_fiscale_format_error_16_chars_no_symbols')
					);
			}
			if (isMarket(Markets.es)) {
				return schema
					.required(i18next.t('required_field'))
					.length(9, i18next.t('codice_fiscale_format_error_9_chars'));
			}
			return schema.required(i18next.t('required_field'));
		},
		otherwise: (schema) => schema.notRequired(),
	}),
	FirstName: Yup.string().when('Cliente__c', {
		is: (value: ClienteEnum) =>
			[ClienteEnum.Libero_Professionista, ClienteEnum.Privato].includes(value),
		then: (schema) => schema.required(i18next.t('required_field')),
	}),
	LastName: Yup.string().when('Cliente__c', {
		is: (value: ClienteEnum) =>
			[ClienteEnum.Libero_Professionista, ClienteEnum.Privato].includes(value),
		then: (schema) => schema.required(i18next.t('required_field')),
	}),
	Email__c: Yup.string().email(i18next.t('email_not_valid')),
	Phone: Yup.string().matches(
		/^\+?\d{1,3}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/,
		i18next.t('phone_not_valid')
	),
	reference_partner: Yup.string().required(i18next.t('required_field')),
	BillingCity: Yup.string().required(i18next.t('required_field')),
	BillingStreet: Yup.string().required(i18next.t('required_field')),
	Flotta_Potenziale_PC__c: Yup.string().when('Cliente__c', {
		is: (value: ClienteEnum) => value === ClienteEnum.Azienda,
		then: (schema) => Yup.number().required(i18next.t('required_field')),
		otherwise: (schema) => schema.notRequired().nullable(),
	}),
	Flotta_Potenziale_LCV__c: Yup.string().when('Cliente__c', {
		is: (value: ClienteEnum) => value === ClienteEnum.Azienda,
		then: (schema) => Yup.number().required(i18next.t('required_field')),
		otherwise: (schema) => schema.notRequired().nullable(),
	}),
	Flotta_Totale_PC__c: Yup.string().when('Cliente__c', {
		is: (value: ClienteEnum) => value === ClienteEnum.Azienda,
		then: (schema) => Yup.number().required(i18next.t('required_field')),
		otherwise: (schema) => schema.notRequired().nullable(),
	}),
	Flotta_Totale_LCV__c: Yup.string().when('Cliente__c', {
		is: (value: ClienteEnum) => value === ClienteEnum.Azienda,
		then: (schema) => Yup.number().required(i18next.t('required_field')),
		otherwise: (schema) => schema.notRequired().nullable(),
	}),
});
